var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"rate-bar-container"},_vm._l((_vm.starNumber),function(item,index){return _c('i',{key:index,staticClass:"icon-star",class:{ active: index + 1 <= _vm.starValue / (100 / _vm.starNumber) },style:(_vm.cssProps),on:{"click":function($event){return _vm.changeRating(index)}}})}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }